import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=06c13e49&scoped=true"
import script from "./fieldset.vue?vue&type=script&lang=js"
export * from "./fieldset.vue?vue&type=script&lang=js"
import style0 from "./fieldset.vue?vue&type=style&index=0&id=06c13e49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c13e49",
  null
  
)

export default component.exports